import { useMasterData } from "../../../hooks/api/useMasterData";
import Refetch from "../../ui/Refetch";

export default function PackageModuleOptionSorting() {

    const { refetchGetBasicPackage, refetchAllPackages } = useMasterData()

    return (
        <div className='w-full flex flex-col'>
            <div className={`flex justify-between `}>
                <p className='text-sm font-medium flex items-center justify-center'>Package list: </p>
                <div className='flex space-x-2'>
                    <Refetch
                        refetch={() => {
                            refetchGetBasicPackage();
                            refetchAllPackages();
                        }} 
                        size={23} 
                        btnStyle={''}
                    />
                </div>
            </div>
        </div>
    )
}
